module.exports = __webpack_public_path__ + "img/margarita.0bc1ec0f.jpg";